import { useMemo } from 'react';

interface UseEstimatedPriceProps {
  options: string[];
  variants: string[];
}

export const useEstimatedPrice = ({ options, variants }: UseEstimatedPriceProps) => {
  const estimatedPrice = useMemo(() => {
    return options.reduce((acc: Record<string, string>, optionData: string, optionIndex: number) => {
      acc[optionData] = variants[optionIndex];
      return acc;
    }, {});
  }, [options, variants]);

  return estimatedPrice;
};
